export const localize_permission_manager = {
    move_all_member_before_delete: "Bạn cần chuyển toàn bộ nhân viên ra khỏi nhóm trước khi thực hiện xóa.",
    delete_group_success: "Xóa thành công nhóm người dùng!",
    cannot_disabled_group: "Không thể ngưng hoạt động nhóm người dùng đang được sử dụng!",
    save_info_group_success: "Lưu thông tin nhóm người dùng thành công!",
    add_info_group_success: "Thêm mới nhóm người dùng thành công!",
    confirm_add_group: "Bạn chắc chắn muốn khởi tạo nhóm người dùng này?",
    confirm_save_info_group: "Bạn chắc chắn muốn lưu thay đổi cho nhóm người dùng này?",
    confirm_delete_group: "Bạn chắc chắn muốn xóa nhóm người dùng này?"
}